import Instruction from "./Instruction";

/**
 * Allow to show a card sample or a form to edit the card username.
 */
class Card extends Instruction
{
	constructor(name)
	{
		super();
		this.name = name;
		this.editable = false;
		this.value = null;
	}
	isEditable(label, submitLabel)
	{
		this.editable = true;
		this.label = label;
		this.submitLabel = submitLabel;

		return this;
	}
	resolve(variables)
	{
		super.resolve(variables);
		this.text = Instruction._resolveValue(this.text, variables);
		this.value = variables[this.name];
	}
}

export default Card
